module.exports = __webpack_public_path__ + "static/media/banner-phone-itCenterKracow.ab1365c1.jpg";